import { site } from "../services/site";
import { eventEmitter } from "../eventEmitters/EventEmitters";

// Mirrors pagesModel.ts's RPC-through-site() pattern for a much smaller,
// non-slotted entity - goal creation/edit isn't a high-frequency action the
// way page select/unselect is (no rapid-click race to guard against with a
// serializing queue), so this stays a plain fetch-then-refresh model:
// mutate via the RPC, re-fetch the full list, emit "goalsUpdated" so both
// RightMenu.tsx's goals table and clusterService.ts's badge rendering react.

export interface GoalEntity {
  _id: string;
  siteId: string;
  name: string;
  destinationUrl: string;
  pageName?: string;
}

export let goalsList: GoalEntity[] = [];

export const getGoalsList = async (siteId: string): Promise<GoalEntity[]> => {
  const response = await site({
    id: 0,
    jsonprc: "2.0",
    method: "getGoals",
    params: { siteId },
  });
  goalsList = response?.data?.result || [];
  eventEmitter.emit("goalsUpdated");
  return goalsList;
};

export const createGoal = async (record: {
  siteId: string;
  name: string;
  destinationUrl: string;
  pageName?: string;
}): Promise<GoalEntity[]> => {
  await site({
    id: 0,
    jsonprc: "2.0",
    method: "createGoal",
    params: record,
  });
  return getGoalsList(record.siteId);
};

export const updateGoal = async (record: {
  goalId: string;
  siteId: string;
  name?: string;
  destinationUrl?: string;
  pageName?: string;
}): Promise<GoalEntity[]> => {
  await site({
    id: 0,
    jsonprc: "2.0",
    method: "updateGoal",
    params: record,
  });
  return getGoalsList(record.siteId);
};

export const deleteGoal = async (record: {
  goalId: string;
  siteId: string;
}): Promise<GoalEntity[]> => {
  await site({
    id: 0,
    jsonprc: "2.0",
    method: "deleteGoal",
    params: record,
  });
  return getGoalsList(record.siteId);
};

export const getGoalForPage = (pageName: string): GoalEntity | undefined =>
  goalsList.find((goal) => goal.pageName === pageName);
